import range from "lodash/range";
import { getYear } from "date-fns";

export const years = range(1950, getYear(new Date()) + 80, 1);
export const months = [
  "datapicker.Month1",
  "datapicker.Month2",
  "datapicker.Month3",
  "datapicker.Month4",
  "datapicker.Month5",
  "datapicker.Month6",
  "datapicker.Month7",
  "datapicker.Month8",
  "datapicker.Month9",
  "datapicker.Month10",
  "datapicker.Month11",
  "datapicker.Month12",
];

export const monthNames = {
  1: "metrics.Month1",
  2: "metrics.Month2",
  3: "metrics.Month3",
  4: "metrics.Month4",
  5: "metrics.Month5",
  6: "metrics.Month6",
  7: "metrics.Month7",
  8: "metrics.Month8",
  9: "metrics.Month9",
  10: "metrics.Month10",
  11: "metrics.Month11",
  12: "metrics.Month12",
};

export const MothcategoriesMetrics = [
  "metrics.Month1",
  "metrics.Month2",
  "metrics.Month3",
  "metrics.Month4",
  "metrics.Month5",
  "metrics.Month6",
  "metrics.Month7",
  "metrics.Month8",
  "metrics.Month9",
  "metrics.Month10",
  "metrics.Month11",
  "metrics.Month12",
];
